/**
 * Возвращает отображение упаковки для карточек заказа.
 *
 * Приоритет источников имени:
 * 1. order.packaging_name_snapshot — снапшот при создании / последней смене упаковки.
 *    Защищает от переименования или удаления упаковки в каталоге (история не «врёт»).
 * 2. Fallback на легаси-захардкод (для старых заказов без снапшота): 'gift'→'Подарочная',
 *    'transport'→'Транспортная'.
 * 3. Иначе — сам packaging_type.
 *
 * Иконка выбирается по типу: 'gift' → подарочная, остальное → транспортная (box).
 *
 * @returns {{label: string, iconSrc: string|null}} iconSrc=null для 'none'.
 */
export function formatOrderPackaging(order) {
  const type = order?.packaging_type;
  if (!type || type === 'none') {
    return { label: 'Без коробки', iconSrc: null };
  }
  const fallback = type === 'gift' ? 'Подарочная'
    : type === 'transport' ? 'Транспортная'
    : type;
  const label = order?.packaging_name_snapshot || fallback;
  const iconSrc = type === 'gift' ? '/icons/nv-gift-package.svg' : '/icons/nv-package.svg';
  return { label, iconSrc };
}
